import { render, staticRenderFns } from "./assign-label-modal.vue?vue&type=template&id=cfb18fa6&scoped=true&"
import script from "./assign-label-modal.vue?vue&type=script&lang=ts&"
export * from "./assign-label-modal.vue?vue&type=script&lang=ts&"
import style0 from "./assign-label-modal.vue?vue&type=style&index=0&id=cfb18fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb18fa6",
  null
  
)

export default component.exports